export const useIsCypressRunning = () => {
  try {
    const isCypressRunning = !!(
      (window as any)?.Cypress || (window?.parent as any)?.Cypress
    );

    return isCypressRunning;
  } catch (_error: any) {
    return false;
  }
};
